import React, { Component } from "react";
import { connect } from "react-redux";
import AddLipShapeWork from "./children/AddLipShapeWork";
import { withTranslation } from "react-i18next";
import "@/assets/addLipShape.less";

class AddLipShape extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageAccept: ".gif, .jpg, .jpeg, .png, .bmp, .tiff, .web, .ico",
    };
  }

  render() {
    const { t } = this.props;
    return (
      <div className="AddLipShape container">
        <h1>{t('AI Face Animator')}</h1>
        <p>{t('Create incredible facial expressions with brainwashing music, find the magic for fun.')}</p>
        <AddLipShapeWork />
      </div>
    );
  }
}

export default connect()(withTranslation(['addLipShape'])(AddLipShape));
